module.exports = __webpack_public_path__ + "/images/logo-powered-stripe.ad462ce.svg";